import * as qs from 'querystring';

import { injectable } from 'inversify';

import { getConfig } from '../ConfigLoader';
import { BranchesRequestData, RectangleRequestData, hasOptionalRequestData } from '../interfaces/search/RequestData';
import { SearchEntries } from '../interfaces/search/SearchEntries';
import {
	AdditionalData,
	OrderBy,
	SearchBranchesCoordBasedRectangleRequest
} from '../interfaces/webservices/core-api-v2/Request/AddressSearches';
import { AddressSearchResult } from '../interfaces/webservices/core-api-v2/Response/AddressSearches';
import { SearchByRectangle } from '../interfaces/webservices/SearchResults';
import { RequestSearch } from './RequestSearch';
import { SearchStorage } from './storage/SearchStorage';
import { ContainerTypes } from './types/ContainerTypes';
import pjsonp from './vendor/pjsonp';

@injectable()
export class RequestSearchByRectangle implements SearchByRectangle {
	public async find(input: RectangleRequestData & BranchesRequestData): Promise<SearchEntries> {
		const { container } = await import('../container');
		const storage = container.get<SearchStorage>(ContainerTypes.SearchStorage);
		const { url, credentials, jsonpOptions } = RequestSearch;
		if (!input.branches) {
			throw new Error('branches must be defined!');
		}
		if (!input.bounds) {
			throw new Error('bounds must be defined!');
		}

		const addition: AdditionalData = {};
		if (hasOptionalRequestData(input)) {
			if (input.distanceTo) {
				addition.LocXForDistanceCalculation = input.distanceTo.lng;
				addition.LocYForDistanceCalculation = input.distanceTo.lat;
			}
			if (input.dataFilters) {
				addition.DataFilter = input.dataFilters;
			}
		}
		addition.AddressListPageSize = getConfig().searchRequest.top;

		const requestData: SearchBranchesCoordBasedRectangleRequest = {
			...credentials,
			Branches: input.branches.join('|'),
			FreeFilter: input.freeFilter || '',
			MaxRadius: input.radius !== undefined ? input.radius : -1,
			OrderBy: OrderBy.DISTANCE,
			Page: input.page || 1,
			Top: getConfig().searchRequest.top,
			Addition: qs.stringify(addition as any),
			IsoCountryCode: input.countryCode || getConfig().defaultCountryCode,
			IsoLocale: input.isoLocale || getConfig().defaultIsoLocale,
			Lux: input.bounds.southWest.lng,
			Luy: input.bounds.northEast.lat,
			Rlx: input.bounds.northEast.lng,
			Rly: input.bounds.southWest.lat,
			CoordFormatIn: 'GEODECIMAL_POINT'
		};
		const result: AddressSearchResult = await pjsonp(
			`${url}SearchBranchesCoordBasedRectangle`,
			requestData,
			jsonpOptions
		);
		storage.setResults(RequestSearch.generateSearchEntries(result, false), input.fitBounds);
		return storage.results;
	}
}
